<div class="d-lg-flex align-items-center bb-light mb-3">
  <h3 class="d-none d-lg-block">Insurance</h3>
</div>
<common-activity-file-upload [activity]="activity"></common-activity-file-upload>
